exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".salesman-update-content{margin:24px 0px}.salesman-update-content div{margin-top:10px}\n", ""]);

// exports
